import config from '../config';

// ✅ Get all MCUs
export const getAllMCUs = async () => {
  const response = await fetch(`${config.apiUrl}/api/mcus`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch MCUs');
  }
  return data;
};

// ✅ Get MCU by MAC address
export const getMCUsByClientId = async (client_id) => {
  const response = await fetch(`${config.apiUrl}/api/mcus/by-client/${client_id}`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch MCU by client');
  }
  return data;
};

// ✅ Get MCU by MAC address
export const getMCUByMAC = async (mac) => {
  const response = await fetch(`${config.apiUrl}/api/mcus/mac/${mac}`);
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch MCU by MAC');
  }
  return data;
};

// ✅ Create new MCU
export const createMCU = async (mcuData) => {
  const response = await fetch(`${config.apiUrl}/api/mcus`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(mcuData),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to create MCU');
  }
  return data;
};

// ✅ Update MCU
export const updateMCU = async (id, updateData) => {
  const response = await fetch(`${config.apiUrl}/api/mcus/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updateData),
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to update MCU');
  }
  return data;
};

// ✅ Delete MCU (soft delete)
export const deleteMCU = async (id) => {
  const response = await fetch(`${config.apiUrl}/api/mcus/${id}`, {
    method: 'DELETE',
  });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Failed to delete MCU');
  }
  return data;
};
